// lib/imageUrl.js
const API_URL = process.env.NEXT_PUBLIC_IMAGES_URL || '/images';

export function getImageUrl(imagePath) {
  if (!imagePath) return null;

  if (imagePath.startsWith('http://') || imagePath.startsWith('https://') || imagePath.startsWith('data:')) {
    return imagePath;
  }

  const cleanPath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;

  if (/^\d+\/logo\.jpg$/.test(cleanPath)) {
    return `${API_URL}/sets/${cleanPath}`;
  }

  return `${API_URL}/${cleanPath}`;
}

// On-demand WebP-thumbnail (backend genereert + cachet, zie server.js).
// Geldige breedtes: 96, 192, 400, 800. Externe/data-URLs en paden zonder
// bekende extensie vallen terug op het origineel.
// De originele extensie blijft in de URL staan (foo.jpg → foo.jpg.192.webp)
// zodat de backend weet welk bronbestand bedoeld is als er zowel een .png
// als een .jpg met dezelfde naam bestaat.
export function getThumbUrl(imagePath, width = 192) {
  if (!imagePath) return null;
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://') || imagePath.startsWith('data:')) {
    return getImageUrl(imagePath);
  }
  const resolved = getImageUrl(imagePath);
  if (!/\.(png|jpe?g)$/i.test(resolved)) return resolved;
  return `${resolved}.${width}.webp`;
}
